<div class="ap-margin-bottom-3">
    {{ 'financial-obligations.credit-card.amount' | coApplicantPipe: store.hasCoApplicant | apContent }}
</div>
<ap-amount-input
    id="creditCardAmount"
    [helpText]="'financial-obligations.credit-card.help-text' | apContent"
    [showSymbol]="true"
    [numberOfDecimals]="0"
    [formControl]="mainApplicantControl"
>
</ap-amount-input>

@if (!store.isSummary) {
    <next-button (click)="nextQuestion()"></next-button>
}
